var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgResident = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    viewBox: "0 0 26 25",
    width: 26,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.0789 18.9474c0-2.3158 1.2737-4.4 3.1264-5.4421-1.5053-.579-3.3579-.9264-5.4421-.9264-5.09478 0-9.2632 2.0843-9.2632 4.6316v2.3158h11.5789zm6.3685-4.0527c-2.2 0-4.0527 1.8527-4.0527 4.0527s1.8527 4.0526 4.0527 4.0526 4.0526-1.8526 4.0526-4.0526-1.8526-4.0527-4.0526-4.0527zm-4.0527-9.26312c0 2.54737-2.0842 4.63162-4.6315 4.63162-2.54741 0-4.63162-2.08425-4.63162-4.63162s2.08421-4.63158 4.63162-4.63158c2.5473 0 4.6315 2.08421 4.6315 4.63158z",
    fill: "#133155"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgResident, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/resident.49f9dde9.svg";
export { ForwardRef as ReactComponent };